import { render, staticRenderFns } from "./BusinessUpsert.vue?vue&type=template&id=70b92cc8"
import script from "./BusinessUpsert.vue?vue&type=script&lang=js"
export * from "./BusinessUpsert.vue?vue&type=script&lang=js"
import style0 from "./BusinessUpsert.vue?vue&type=style&index=0&id=70b92cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports